import React from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

export default function MyTournamentsDashboardSection({ dashboard, loading }) {
  const d = dashboard || {};

  const items = [
    {
      key: "total",
      label: "Total Tournaments",
      value: d.total_tournaments ?? 0,
      tone: "teal",
    },
    {
      key: "upcoming",
      label: "Upcoming Tournaments",
      value: d.upcoming_tournaments ?? 0,
      tone: "blue",
    },
    {
      key: "ongoing",
      label: "Ongoing Tournaments",
      value: d.ongoing_tournaments ?? 0,
      tone: "mint",
    },
    {
      key: "completed",
      label: "Completed Tournaments",
      value: d.completed_tournaments ?? 0,
      tone: "purple",
    },
    {
      key: "certificates",
      label: "Certificates Earned",
      value: d.certificates_earned ?? 0,
      tone: "coral",
    },
    {
      key: "participations",
      label: "Total Participations",
      value: d.total_participations ?? 0,
      tone: "slate",
    },
  ];

  return (
    <section className="user-builder-panel" aria-label="Tournament dashboard">
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Tournament overview</h3>
        <p className="user-builder-panel__hint">
          Snapshot of your registrations across upcoming, ongoing, and completed
          tournaments.
        </p>
      </div>
      <GlobalMetricCards
        items={items}
        loading={loading}
        skeletonCount={6}
        gridClassName="mt-metrics-grid"
        ariaLabel="My tournaments dashboard metrics"
      />
    </section>
  );
}
